// @flow
import * as React from "react";
import formatDates from "../../common/formatDates";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { useMemo } from "react";
import _ from "lodash";
import type { Ranking, Rankings } from "../../common/types";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import RankingsRow from "./RankingsRow";

function RankingsTable() {
  const firestore = useFirestore();
  const rankingsRef = firestore.collection("sams").doc("rankings");
  const rankings: Rankings = useFirestoreDocData(rankingsRef);
  const ranking: Array<Ranking> = useFirestoreCollectionData(
    rankingsRef.collection("ranking")
  );

  const rankingSorted = useMemo(() => _.orderBy(ranking, ["place", "asc"]), [
    ranking,
  ]);

  return (
    <>
      {rankingSorted.map((row: Ranking) => (
        <RankingsRow key={row.teamId} ranking={row} />
      ))}
      <Box mt={1}>
        <Typography variant="caption" color="textSecondary">
          <b>SP:</b> Spiele, <b>S:</b> Siege, <b>N:</b> Niederlagen, <b>Pt:</b>{" "}
          Punkte
          <br />
          Graphen zeigen den Verlauf der Platzierung pro Woche.
          <br />
          Stand: {formatDates.ISODateAndTime(rankings.updated)}
          <br />
          {rankings.name}
        </Typography>
      </Box>
    </>
  );
}

export default RankingsTable;
